module.exports = __webpack_public_path__ + "img/MEDIA013.667537a6.jpg";